<template>
    <div>
        <v-container fluid>
            <div class="text-h5 text-sm-h5 text-md-h4 ma-3 text-center">
                Hoja Material Auxiliar
            </div>

            <!-- ── FILTROS ─────────────────────────────────────────────────── -->
            <v-card class="pa-4 mb-4" elevation="2">
                <v-form ref="form" :disabled="loading">
                    <v-row align="center">

                        <v-col cols="6" sm="4" md="2" class="mb-n4">
                            <v-text-field
                                v-model="filtros.FechaDesde"
                                label="Fecha Desde"
                                type="date"
                                outlined dense hide-details color="primary"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="4" md="2" class="mb-n4">
                            <v-text-field
                                v-model="filtros.FechaHasta"
                                label="Fecha Hasta"
                                type="date"
                                outlined dense hide-details color="primary"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="3" md="1" class="mb-n4">
                            <v-text-field
                                v-model.number="filtros.AlmacenDesde"
                                label="Tienda desde"
                                type="number" min="1"
                                outlined dense hide-details color="primary"
                            ></v-text-field>
                        </v-col>

                        <v-col cols="6" sm="3" md="1" class="mb-n4">
                            <v-text-field
                                v-model.number="filtros.AlmacenHasta"
                                label="Tienda hasta"
                                type="number" min="1"
                                outlined dense hide-details color="primary"
                            ></v-text-field>
                        </v-col>

                    </v-row>

                    <!-- Botones -->
                    <v-row class="mt-4" align="center">

                        <v-col cols="auto">
                            <v-btn color="primary" :loading="loading" @click="calcular">
                                <v-icon left>mdi-calculator</v-icon>
                                Calcular
                            </v-btn>
                        </v-col>

                        <v-col cols="auto">
                            <v-btn color="primary" :disabled="!hayDatos" @click="imprimir">
                                <v-icon left>mdi-printer</v-icon>
                                Imprimir
                            </v-btn>
                        </v-col>

                        <v-col cols="auto">
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <span v-on="on">
                                        <v-btn color="primary" disabled>
                                            <v-icon left>mdi-book-account</v-icon>
                                            Contabilizar
                                        </v-btn>
                                    </span>
                                </template>
                                <span>Pendiente: tablas fsrNomg/fsrNoma no creadas en Ekon</span>
                            </v-tooltip>
                        </v-col>

                    </v-row>
                </v-form>
            </v-card>

            <!-- ── RESULTADO: una sección por codemp ─────────────────────── -->
            <template v-if="hayDatos">

                <v-card
                    v-for="grupo in lineasPorEmpresa"
                    :key="grupo.codEmp"
                    class="mb-4"
                    elevation="2"
                >
                    <v-card-title class="text-subtitle-1 font-weight-bold py-2 px-4">
                        Empresa: {{ grupo.codEmp }}
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <div style="overflow-x: auto">
                            <table class="tabla-mataux">
                                <thead>
                                    <tr>
                                        <th class="col-tienda">Tienda</th>
                                        <th>Mat.Aux.</th>
                                        <th>Bolsas</th>
                                        <th>B.Repos</th>
                                        <th>B.Bague</th>
                                        <th>B.Past</th>
                                        <th>C.Past</th>
                                        <th>P.Ind</th>
                                        <th>SUMA</th>
                                        <th>Globos</th>
                                        <th>SUMA</th>
                                        <th>M.Ofi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="l in grupo.lineas" :key="l.Codigo">
                                        <td class="col-tienda">{{ l.NombreRemoto }}</td>
                                        <td>{{ fn(l.MatAux) }}</td>
                                        <td>{{ fn(l.Bolsas) }}</td>
                                        <td>{{ fn(l.BRepos) }}</td>
                                        <td>{{ fn(l.BBague) }}</td>
                                        <td>{{ fn(l.BPast) }}</td>
                                        <td>{{ fn(l.CPast) }}</td>
                                        <td>{{ fn(l.PInd) }}</td>
                                        <td>{{ fn(l.SumaEnvases) }}</td>
                                        <td>{{ fn(l.Globos) }}</td>
                                        <td>{{ fn(l.SumaTotal) }}</td>
                                        <td>{{ fn(l.MatOfi) }}</td>
                                    </tr>
                                    <!-- Subtotales por empresa — formato 99999.99 igual que FoxPro -->
                                    <tr class="fila-subtotales">
                                        <td class="col-tienda">TOTALES</td>
                                        <td>{{ fn5(grupo.totales.MatAux) }}</td>
                                        <td>{{ fn5(grupo.totales.Bolsas) }}</td>
                                        <td>{{ fn5(grupo.totales.BRepos) }}</td>
                                        <td>{{ fn5(grupo.totales.BBague) }}</td>
                                        <td>{{ fn5(grupo.totales.BPast) }}</td>
                                        <td>{{ fn5(grupo.totales.CPast) }}</td>
                                        <td>{{ fn5(grupo.totales.PInd) }}</td>
                                        <td>{{ fn5(grupo.totales.SumaEnvases) }}</td>
                                        <td>{{ fn5(grupo.totales.Globos) }}</td>
                                        <td>{{ fn5(grupo.totales.SumaTotal) }}</td>
                                        <td>{{ fn5(grupo.totales.MatOfi) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-card-text>
                </v-card>

                <!-- Totales globales al final — igual que la fila TOTALES del FoxPro -->
                <v-card elevation="2">
                    <v-card-title class="text-subtitle-1 font-weight-bold py-2 px-4">
                        Totales generales
                    </v-card-title>
                    <v-card-text class="pa-0">
                        <div style="overflow-x: auto">
                            <table class="tabla-mataux">
                                <thead>
                                    <tr>
                                        <th class="col-tienda"></th>
                                        <th>Mat.Aux.</th>
                                        <th>Bolsas</th>
                                        <th>B.Repos</th>
                                        <th>B.Bague</th>
                                        <th>B.Past</th>
                                        <th>C.Past</th>
                                        <th>P.Ind</th>
                                        <th>SUMA</th>
                                        <th>Globos</th>
                                        <th>SUMA</th>
                                        <th>M.Ofi</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr class="fila-totales-globales">
                                        <td class="col-tienda">TOTALES</td>
                                        <td>{{ fn5(totalesGlobales.MatAux) }}</td>
                                        <td>{{ fn5(totalesGlobales.Bolsas) }}</td>
                                        <td>{{ fn5(totalesGlobales.BRepos) }}</td>
                                        <td>{{ fn5(totalesGlobales.BBague) }}</td>
                                        <td>{{ fn5(totalesGlobales.BPast) }}</td>
                                        <td>{{ fn5(totalesGlobales.CPast) }}</td>
                                        <td>{{ fn5(totalesGlobales.PInd) }}</td>
                                        <td>{{ fn5(totalesGlobales.SumaEnvases) }}</td>
                                        <td>{{ fn5(totalesGlobales.Globos) }}</td>
                                        <td>{{ fn5(totalesGlobales.SumaTotal) }}</td>
                                        <td>{{ fn5(totalesGlobales.MatOfi) }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </v-card-text>
                </v-card>

            </template>

            <v-alert v-else-if="buscado" type="info" outlined class="mt-4">
                No hay datos para los filtros seleccionados.
            </v-alert>

        </v-container>
    </div>
</template>

<script>
import axios from "axios";
import { mapState } from "vuex";

export default {
    name: "MatAuxResumen",
    computed: {
        ...mapState(['urlRaiz']),

        hayDatos () { return this.lineas.length > 0; },

        // Agrupa las líneas por codemp, igual que el report FoxPro
        // Cada grupo incluye sus líneas y sus subtotales
        lineasPorEmpresa () {
            const grupos = [];
            const map    = {};
            const COLS   = ['MatAux','Bolsas','BRepos','BBague','BPast','CPast','PInd','Globos','MatOfi','SumaEnvases','SumaTotal'];

            this.lineas.forEach(l => {
                if (!map[l.CodEmp]) {
                    const g = {
                        codEmp:  l.CodEmp,
                        lineas:  [],
                        totales: Object.fromEntries(COLS.map(c => [c, 0]))
                    };
                    map[l.CodEmp] = g;
                    grupos.push(g);
                }
                const g = map[l.CodEmp];
                g.lineas.push(l);
                COLS.forEach(c => { g.totales[c] = +(g.totales[c] + (l[c] || 0)).toFixed(2); });
            });

            return grupos;
        },

        // Totales globales (suma de todos los grupos)
        totalesGlobales () {
            const COLS = ['MatAux','Bolsas','BRepos','BBague','BPast','CPast','PInd','Globos','MatOfi','SumaEnvases','SumaTotal'];
            const tot  = Object.fromEntries(COLS.map(c => [c, 0]));
            this.lineas.forEach(l => {
                COLS.forEach(c => { tot[c] = +(tot[c] + (l[c] || 0)).toFixed(2); });
            });
            return tot;
        }
    },
    data () {
        return {
            loading: false,
            buscado: false,
            lineas:  [],
            filtros: {
                FechaDesde:   this.primerDiaMesActual(),
                FechaHasta:   this.ultimoDiaMesActual(),
                AlmacenDesde: 1,
                AlmacenHasta: 99
            }
        };
    },
    methods: {

        primerDiaMesActual () {
            const d = new Date();
            return `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}-01`;
        },
        ultimoDiaMesActual () {
            const d  = new Date();
            const ul = new Date(d.getFullYear(), d.getMonth()+1, 0);
            return `${ul.getFullYear()}-${String(ul.getMonth()+1).padStart(2,'0')}-${String(ul.getDate()).padStart(2,'0')}`;
        },

        // ── Calcular ────────────────────────────────────────────────────────
        calcular () {
            if (!this.validarFiltros()) return;
            this.loading = true;
            this.buscado = false;
            const AuthToken = localStorage.getItem('token');
            axios({
                method: "POST",
                url:    this.urlRaiz + "/api/mataux-resumen/calcular",
                data:   JSON.stringify(this.getPayload()),
                headers: { "content-type": "application/json", "Authorization": AuthToken }
            })
            .then(r => {
                // Añadir SumaEnvases y SumaTotal calculados (igual que el report FoxPro)
                this.lineas = (r.data.Lineas || []).map(l => ({
                    ...l,
                    // +b_repos + b_bague + b_past + c_past + p_ind
                    SumaEnvases: +(l.BRepos + l.BBague + l.BPast + l.CPast + l.PInd).toFixed(2),
                    // =b_repos + b_bague + b_past + c_past + p_ind + bolsas + globos
                    SumaTotal:   +(l.BRepos + l.BBague + l.BPast + l.CPast + l.PInd + l.Bolsas + l.Globos).toFixed(2)
                }));
                this.buscado = true;
            })
            .catch(e => alert('Error al calcular: ' + (e.response?.data ?? e.message)))
            .finally(() => { this.loading = false; });
        },

        // ── Imprimir — fiel al report FoxPro ────────────────────────────────
        // - Calibri (font del proyecto), cabeceras Black/White como los RDLC
        // - Datos:     formato "9999.99"
        // - Subtotales por empresa: formato "99999.99" igual que el FRT
        // - Salto de página entre empresas
        // - Fila TOTALES global al final
        imprimir () {
            const fDesde = this.formatDate(this.filtros.FechaDesde);
            const fHasta = this.formatDate(this.filtros.FechaHasta);

            // Cabeceras de columna (igual que el FRT)
            const thCols = `
                <th class="izq">Tienda</th>
                <th>MAT.AUX.</th><th>BOLSAS</th><th>B.REPOS</th><th>B.BAGUE</th>
                <th>B.PAST</th><th>C.PAST</th><th>P.IND</th><th>SUMA</th>
                <th>GLOBOS</th><th>SUMA</th><th>M.OFI</th>`;

            // Fila de datos — formato 9999.99 (igual que FRT datos)
            const fmtDato = v => (v == null || isNaN(v)) ? '' : parseFloat(v).toFixed(2);

            // Fila de subtotales — formato 99999.99 (igual que FRT subtotales)
            const fmtSub  = v => (v == null || isNaN(v)) ? '' : parseFloat(v).toFixed(2);

            const trDato = l => `<tr>
                <td class="izq">${l.NombreRemoto}</td>
                <td>${fmtDato(l.MatAux)}</td><td>${fmtDato(l.Bolsas)}</td>
                <td>${fmtDato(l.BRepos)}</td><td>${fmtDato(l.BBague)}</td>
                <td>${fmtDato(l.BPast)}</td><td>${fmtDato(l.CPast)}</td>
                <td>${fmtDato(l.PInd)}</td><td>${fmtDato(l.SumaEnvases)}</td>
                <td>${fmtDato(l.Globos)}</td><td>${fmtDato(l.SumaTotal)}</td>
                <td>${fmtDato(l.MatOfi)}</td>
            </tr>`;

            const trSub = (t, label) => `<tr class="subtotales">
                <td class="izq">${label}</td>
                <td>${fmtSub(t.MatAux)}</td><td>${fmtSub(t.Bolsas)}</td>
                <td>${fmtSub(t.BRepos)}</td><td>${fmtSub(t.BBague)}</td>
                <td>${fmtSub(t.BPast)}</td><td>${fmtSub(t.CPast)}</td>
                <td>${fmtSub(t.PInd)}</td><td>${fmtSub(t.SumaEnvases)}</td>
                <td>${fmtSub(t.Globos)}</td><td>${fmtSub(t.SumaTotal)}</td>
                <td>${fmtSub(t.MatOfi)}</td>
            </tr>`;

            // Construir secciones por empresa con salto de página entre ellas
            let cuerpo = '';
            this.lineasPorEmpresa.forEach((grupo, idx) => {
                const salto = idx > 0 ? 'page-break-before: always;' : '';
                cuerpo += `
                <div style="${salto}">
                  <div class="emp-header">Empresa: ${grupo.codEmp}</div>
                  <table>
                    <thead><tr>${thCols}</tr></thead>
                    <tbody>
                      ${grupo.lineas.map(trDato).join('')}
                      ${trSub(grupo.totales, 'TOTALES')}
                    </tbody>
                  </table>
                </div>`;
            });

            // Fila TOTALES global al final (igual que el FRT)
            cuerpo += `
                <div style="margin-top: 8mm;">
                  <table>
                    <thead><tr>${thCols}</tr></thead>
                    <tbody>${trSub(this.totalesGlobales, 'TOTALES')}</tbody>
                  </table>
                </div>`;

            const html = `<!DOCTYPE html>
<html lang="es"><head><meta charset="UTF-8"><title>Hoja Material Auxiliar</title>
<style>
  * { box-sizing: border-box; margin: 0; padding: 0; }
  body {
    font-family: Calibri, "Segoe UI", Arial, sans-serif;
    font-size: 8pt;
    color: #000;
    margin: 12mm 8mm 10mm 8mm;
  }
  .titulo   { font-size: 18pt; font-weight: bold; text-align: center; margin-bottom: 1mm; }
  .subtitulo{ font-size: 8pt; text-align: center; margin-bottom: 6mm; color: #444; }
  .emp-header {
    font-size: 9pt;
    font-weight: bold;
    margin: 4mm 0 2mm 0;
  }
  table { border-collapse: collapse; width: 100%; margin-bottom: 2mm; }
  th {
    background-color: #000;
    color: #fff;
    padding: 2px 3px;
    text-align: right;
    border: 1px solid #d3d3d3;
    font-weight: normal;
    font-size: 8pt;
    white-space: nowrap;
  }
  th.izq { text-align: left; }
  td {
    padding: 2px 3px;
    border: 1px solid #d3d3d3;
    text-align: right;
    font-size: 8pt;
    white-space: nowrap;
  }
  td.izq { text-align: left; }
  /* Subtotales por empresa — negrita, borde superior doble (igual que FRT) */
  tr.subtotales td {
    font-weight: bold;
    border-top: 2px solid #000;
  }
  @media print {
    @page { size: A4 landscape; margin: 8mm; }
    body  { margin: 0; }
  }
</style></head><body>
<div class="titulo">HOJA MATERIAL AUXILIAR</div>
<div class="subtitulo">DEL ${fDesde} AL ${fHasta}</div>
${cuerpo}
</body></html>`;

            const w = window.open('', '_blank', 'width=1200,height=750');
            w.document.write(html);
            w.document.close();
            w.focus();
            w.onafterprint = () => w.close();
            setTimeout(() => { w.print(); }, 400);
        },

        // ── Helpers ─────────────────────────────────────────────────────────

        validarFiltros () {
            if (!this.filtros.FechaDesde || !this.filtros.FechaHasta) {
                alert('Indica el rango de fechas.'); return false;
            }
            if (this.filtros.FechaHasta < this.filtros.FechaDesde) {
                alert('La fecha hasta no puede ser menor que la fecha desde.'); return false;
            }
            if (this.filtros.AlmacenHasta < this.filtros.AlmacenDesde) {
                alert('La tienda hasta no puede ser menor que la tienda desde.'); return false;
            }
            return true;
        },

        getPayload () {
            return {
                FechaDesde:   this.filtros.FechaDesde,
                FechaHasta:   this.filtros.FechaHasta,
                AlmacenDesde: this.filtros.AlmacenDesde,
                AlmacenHasta: this.filtros.AlmacenHasta
            };
        },

        // Formato datos: 9999.99 (igual que el FRT para filas de detalle)
        fn (v) {
            if (v == null || isNaN(v)) return '';
            return parseFloat(v).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        // Formato subtotales: 99999.99 (igual que el FRT para filas de totales)
        fn5 (v) {
            if (v == null || isNaN(v)) return '';
            return parseFloat(v).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },

        formatDate (v) {
            if (!v) return '';
            const [y, m, d] = v.split('-');
            return `${d}/${m}/${y}`;
        }
    }
};
</script>

<style>
/* Tabla de material auxiliar — estilo RDLC del proyecto */
.tabla-mataux {
    border-collapse: collapse;
    width: 100%;
    font-size: 12px;
}
.tabla-mataux th {
    background-color: #000;
    color: #fff;
    padding: 4px 6px;
    text-align: right;
    border: 1px solid #d3d3d3;
    font-weight: normal;
    white-space: nowrap;
}
.tabla-mataux th.col-tienda { text-align: left; min-width: 180px; }
.tabla-mataux td {
    padding: 3px 6px;
    border: 1px solid #d3d3d3;
    text-align: right;
    white-space: nowrap;
}
.tabla-mataux td.col-tienda { text-align: left; }

/* Subtotales por empresa */
.tabla-mataux tr.fila-subtotales td {
    font-weight: bold;
    border-top: 2px solid #000;
    background-color: #f5f5f5;
}

/* Totales globales */
.tabla-mataux tr.fila-totales-globales td {
    font-weight: bold;
    border-top: 2px solid #000;
    background-color: #e3f0fb;
}
</style>
